<script lang="ts">
  // Small honest inline SVG bar — no chart library. One labeled row: a
  // proportional bar (value/max) plus the raw count, so the number is
  // always visible next to the bar that represents it.
  const { label, value, max }: { label: string; value: number; max: number } = $props();
  const pct = $derived(max > 0 ? Math.max(value > 0 ? 3 : 0, (value / max) * 100) : 0);
</script>

<div class="flex items-center gap-3">
  <span class="w-[42%] shrink-0 truncate text-[13px] text-dark-gray">{label}</span>
  <svg viewBox="0 0 100 10" preserveAspectRatio="none" class="h-2.5 flex-1" role="img" aria-label="{label}: {value}">
    <rect class="tym-barrow-track" x="0" y="0" width="100" height="10" rx="5" />
    <rect class="tym-barrow-fill" x="0" y="0" width={pct} height="10" rx="5" />
  </svg>
  <span class="w-8 shrink-0 text-right text-[13px] font-semibold tabular-nums text-navy">{value}</span>
</div>
